import AppTabs from '../../components/AppTabs/AppTabs';
import SdoAdminUsageReportsTab from './SdoAdminUsageReportsTab';
import SdoAdminMonthlyReportsTab from './SdoAdminMonthlyReportsTab';
import { useTranslation } from 'react-i18next';
import './SdoAdminTabs.scss';

export default function SdoAdminTabs({ tabValue, handleTabChange }) {
    const { t } = useTranslation();

    const requestlistNoData = [
        {
            "id": "1",
            "year": new Date().getFullYear(),
			"month": "-",
            "submissionClosed": "-",
            "publishedOn": "Not available yet",
			"lastUpdated": "-",
			"cycleStatus" : "Open",
            "requests": "-",
            "approved": "-",
			"declined": "-",
			"unused": "-",
        }
    ]
 
    const getTabElements = () => {
        const tabElement1 = <SdoAdminMonthlyReportsTab requestlistNoData={requestlistNoData} />
        const tabElement2 = <SdoAdminUsageReportsTab requestlistNoData={requestlistNoData}/>
        return [tabElement1, tabElement2];
    }

    const getTabLabels = () => {
        const tabLabels1 = t("specialDayOffAdmin.sdoAdminTabs.sdoRequestTab");
        const tabLabels2 = t("specialDayOffAdmin.sdoAdminTabs.sdoUsageTab");
        return [tabLabels1, tabLabels2];
    }

    return (
        <>
            <div className='sdo-admin-req-tabs__divider' />
            <div className='sdo-admin-req-tabs__cntr'>
                <AppTabs tabLabels={getTabLabels()} tabElements={getTabElements()} handleTabChange={handleTabChange} tabValue={tabValue} />
            </div>
        </>

    )
}
